<template>
  <div id="sezzle-widget"></div>
</template>

<script>
import { loadScriptAsync } from 'Root/helpers/tools';

let renderSezzle;

export default {
  name: 'SezzleWidget',

  props: {
    price: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isWidgetReady: false,
    };
  },

  watch: {
    price(val) {
      if (this.isWidgetReady) {
        renderSezzle.alterPrice(val);
      }
    },
  },

  async mounted() {
    // Документация к виджету - https://docs.sezzle.com/docs/guides/widgets/static
    if (typeof window.AwesomeSezzle === 'undefined') {
      await loadScriptAsync('/js_external/sezzle.js');
    }

    // eslint-disable-next-line no-undef
    renderSezzle = new AwesomeSezzle({
      amount: this.price,
      theme: 'dark',
      widgetTemplate: 'Or pay now only %%price%% and remaining part later with no interest using %%logo%% %%info%%',
      modalTheme: 'color',
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      alignment: 'left',
      alignmentSwitchType: 'center',
      textColor: '#eee',
      fontFamily: 'Comfortaa, sans-serif',
      fontSize: 12,
      fontWeight: 400,
      widgetType: 'product-page',
      fixedHeight: 0,
      logoSize: 1.0,
    });

    renderSezzle.init();

    this.isWidgetReady = true;
  },
};
</script>

<style scoped>
#sezzle-widget {
  border-radius: 5px;
  background-color: #382757;
  padding: 12px;
  display: block;
}
</style>
